var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-header'),_c('div',{staticStyle:{"padding":"10px"}},[_c('div',{staticStyle:{"margin":"0px auto","padding-bottom":"50px","max-width":"1200px"}},[_c('router-view')],1)]),_c('my-gotop'),_c('div',{staticStyle:{"text-align":"center","color":"#ccc"}},[_vm._v("\n    系统版本 V1.0.0\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }